import { NotificationEntry } from "../models/NotificationEntry.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Staff notification bell: list, unread count, mark read. */
export class NotificationViewModel extends ViewModel {
    client;
    siteSlug;
    readStore;
    constructor(client, siteSlug, readStore) {
        super({ items: [], loading: false, error: null });
        this.client = client;
        this.siteSlug = siteSlug;
        this.readStore = readStore;
    }
    get unreadCount() {
        return this.state.items.filter((i) => !i.read).length;
    }
    /** Seed rows without hitting the API (previews, tests). */
    seed(items) {
        this.setState({ items, error: null });
    }
    async load() {
        try {
            const list = await this.client.listNotifications();
            let listings = new Map();
            try {
                listings = new Map((await this.client.listListings(this.siteSlug)).map((l) => [l.id, l]));
            }
            catch {
                // Car labels are best-effort; rows still render.
            }
            const readIds = this.readStore?.load() ?? new Set();
            this.setState({
                items: list.map((n) => NotificationEntry.fromStaff(n, listings, readIds)),
                error: null,
            });
        }
        catch {
            this.setState({ error: "Notifications API is not available yet." });
        }
    }
    async markRead(id) {
        this.readStore?.add(id);
        this.setState({
            items: this.state.items.map((i) => (i.id === id ? i.withRead() : i)),
        });
        try {
            await this.client.markNotificationRead(id);
        }
        catch {
            this.setState({ error: "Could not mark notification read." });
        }
    }
}
//# sourceMappingURL=NotificationViewModel.js.map